import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{on:{"change":function($event){return _vm.$emit('dialog-closed', _vm.dialog)}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c(VCard,[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }